import { render, staticRenderFns } from "./CourseAuthorList.vue?vue&type=template&id=18adf078&scoped=true&"
import script from "./CourseAuthorList.vue?vue&type=script&lang=js&"
export * from "./CourseAuthorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18adf078",
  null
  
)

export default component.exports